import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/data/sponsors";

export const LegalLayout = ({ title, updated, children, testId }) => (
  <div className="min-h-screen bg-[#FAF9F6]" data-testid={testId}>
    <header className="border-b border-[#E8E2E4] bg-white">
      <div className="mx-auto flex max-w-[900px] items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={LOGO_URL} alt="DonnaImpresa" className="h-9 w-9 rounded-xl object-cover" />
          <span className="font-display text-lg">
            Donna<span className="text-[#E0708A]">Impresa</span>
          </span>
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#6B5E62] di-underline"
        >
          <ArrowLeft size={14} /> Torna al sito
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-[900px] px-5 py-16 sm:px-8">
      <h1 className="font-display text-4xl tracking-tight text-[#1A1617] sm:text-5xl">
        {title}
      </h1>
      <p className="mt-3 text-sm text-[#6B5E62]">Ultimo aggiornamento: {updated}</p>
      <div className="mt-12 space-y-8 text-[#6B5E62]">{children}</div>
    </main>
  </div>
);

export const Sez = ({ titolo, children }) => (
  <section>
    <h2 className="font-display text-2xl text-[#1A1617]">{titolo}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed">{children}</div>
  </section>
);
